module.exports = __webpack_public_path__ + "img/quizzes_bg1400.fcd749d2.jpg";